module.exports = __webpack_public_path__ + "media/assets/icons/ic-edit-701cb55023169977a562a872c59845a0.svg";